// components/ProtectedLayout.js
import React from 'react';

const ProtectedLayout = ({ children }) => {
  return (
   
    
      <div className="content">{children}</div>
   
  );
};

export default ProtectedLayout;
